import { render, staticRenderFns } from "./ClientCardContainer.vue?vue&type=template&id=e917dca8&scoped=true&"
import script from "./ClientCardContainer.vue?vue&type=script&lang=js&"
export * from "./ClientCardContainer.vue?vue&type=script&lang=js&"
import style0 from "./ClientCardContainer.vue?vue&type=style&index=0&id=e917dca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e917dca8",
  null
  
)

export default component.exports